import { createComponent } from '@carvana/merch-components';

export const HeroImage = createComponent('img', {
  className: 'absolute inset-0 h-full w-full object-cover opacity-30 grayscale'
});

export const Placeholder = createComponent('div', {
  className:
    'relative flex h-full w-full items-center justify-center bg-background-muted-hint'
});
